export const getTypographyStyles = (fontWeight?: string) => ({
  textAlign: 'left',
  display: '-webkit-box',
  WebkitLineClamp: '2',
  WebkitBoxOrient: 'vertical' as const,
  overflow: 'hidden',
  fontSize: '14px',
  fontWeight: navigator?.userAgent.includes('Firefox')
    ? fontWeight ?? '400'
    : fontWeight ?? '500',
})

export const getBoxStyles = (justifyContent?: string) => ({
  justifyContent: justifyContent ?? 'start',
  margin: '0 auto',
  height: 'calc(56px - 16px)',
  display: 'flex',
  alignItems: 'center',
  width: 'max-content',
  maxWidth: '100%',
})
